var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "section",
      class: { "bigger-section": _vm.focus },
      attrs: { id: "informations" }
    },
    [
      _vm.withTitle
        ? _c("div", { staticClass: "section-title" }, [
            _vm._v("\n    INFORMAÇÕES SOBRE A LIMPEZA\n    "),
            _c("hr")
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("small", [
        _vm._v(
          "\n    Quando você preencher as informações ou instruções para o profissional, o próximo passo para finalizar a compra irá aparecer.\n  "
        )
      ]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "section-body" }, [
        _c("textarea", {
          ref: "description",
          staticClass: "add-information",
          class: {
            "has-error": _vm.additional_informations.length === 1023,
            pulse: _vm.focus
          },
          attrs: {
            placeholder:
              'Escreva aqui as instruções e cuidados para a limpeza. Por exemplo: "Fazer a limpeza do banheiro, quartos, sala e cozinha. Foco na limpeza do box, retirar mofo da parede da sala, limpeza dos pisos e retirada de pó. Por favor, afaste os móveis para limpar embaixo"...',
            name: "description",
            rows: "5",
            maxlength: "1023"
          },
          domProps: { value: _vm.additional_informations },
          on: {
            input: function($event) {
              _vm.setAdditionalInformations($event.target.value)
            },
            focus: function($event) {
              _vm.focus()
            }
          }
        })
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("small", [
      _c("b", [_vm._v("Importante:")]),
      _vm._v(" o profissional "),
      _c("b", [_vm._v("não levará balde, vassoura, rodo e escada.")]),
      _vm._v(
        " Se esses itens forem necessários, devem estar disponíveis no local da limpeza.\n  "
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-41f223f6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41f223f6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PurchaseFlow/Steps/AdditionalInformations.vue
// module id = null
// module chunks = 